import { useContextSelector } from 'use-context-selector';
import 'react';
import '@emotion/react';
import '../contexts/internal/StickyContext.js';
import { EditorContext } from '../contexts/internal/EditorContext.js';
import { findNode } from '../utils/node.js';

function useEditorNodeData() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var node = useContextSelector(EditorContext, function (context) {
    return context != null ? findNode(context.state.document, path) : null;
  });
  if (node == null) {
    throw new Error('The path cannot be found');
  }
  var component = useContextSelector(EditorContext, function (context) {
    return context === null || context === void 0 ? void 0 : context.components[node.type];
  });
  if (component == null) {
    throw new Error('The component cannot be found');
  }
  return {
    node: node,
    component: component
  };
}

export { useEditorNodeData };
//# sourceMappingURL=useEditorNodeData.js.map
